import http from './httpRequest.js'

export function getAllConversationsV2(page = 1, pageSize = 0) {
	return http({
		url: '/api/v1/customer/conversation_all_v2',
		method: 'get',
		params: { page, pageSize }
	})
}

export function getConversationLabels() {
	return http({
		url: '/api/v1/customer/conversation_label',
		method: 'get'
	})
}

export function addConversationLabel(data) {
	return http({
		url: '/api/v1/customer/add_conversation_label',
		method: 'post',
		data: data
	})
}

export function deleteConversationLabel(data) {
	return http({
		url: '/api/v1/customer/delete_conversation_label',
		method: 'delete',
		data: data
	})
}

export function pinnedConversation(data) {
	return http({
		url: '/api/v1/customer/pinned_conversation',
		method: 'post',
		data: data
	})
}

// 屏蔽/恢复群消息（消息免打扰，仅群聊会话，客服维度）
export function dndConversation(data) {
	return http({
		url: '/api/v1/customer/dnd_conversation',
		method: 'post',
		data: data
	})
}

export function remarkConversation(data) {
	return http({
		url: '/api/v1/customer/remark_conversation',
		method: 'post',
		data: data
	})
}

export function deleteConversation(data) {
	return http({
		url: '/api/v1/customer/delete_conversation',
		method: 'delete',
		data: data
	})
}

// 撤回消息（单聊/群聊通用，后端按 conversationID + messageID 定位）
export function recallMessage(data) {
	return http({
		url: '/api/v1/customer/recall_message',
		method: 'post',
		data: data
	})
}

export function markConversationGroup(data) {
	return http({
		url: '/api/v1/customer/mark_conversation_group',
		method: 'post',
		data: data
	})
}
